import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.VITE_SUPABASE_URL,
  process.env.VITE_SUPABASE_PUBLISHABLE_KEY,
);

export function SupabaseListener() {
  const [isOpen, setIsOpen] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  useEffect(() => {
    const channel = supabase.channel('petrometer');
    channel
      .on('broadcast', { event: 'reload' }, (payload) => {
        setIsOpen(true);
        setAlertContent(payload.payload.message);
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      contentLabel="Manage subscription modal"
      shouldCloseOnOverlayClick={true}
      className="sub-xl-modal-container"
      overlayClassName="xl-modal-overlay"
      parentSelector={() =>
        document.querySelector('.page-components') ||
        document.getElementById('root')
      }
      style={{
        content: {
          width: '50%',
        },
      }}
    >
      <div
        className="update-modal"
        style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: alertContent }} />
      </div>
    </Modal>
  );
}
